import RestApi from '@/core/services/RestApi'

export default {
  createDeleteMixin({
    componentRefName = 'rest-list',
    getWarningItems = []
  } = {}) {
    return {
      data() {
        return {
          showWarningDialog: false,
          showConfirmDialog: false,
          currentItem: null
        }
      },

      methods: {
        confirmDelete(item) {
          this.currentItem = item
          this.showWarningDialog = true
        },
        cancelDelete() {
          this.showWarningDialog = false
          this.showConfirmDialog = false
          this.currentItem = null
        },
        proceedToConfirm() {
          this.showWarningDialog = false
          this.showConfirmDialog = true
        },
        executeDelete(deleteEndpointFn) {
          if (!this.currentItem) return

          const endpoint = deleteEndpointFn(this.currentItem)

          RestApi(endpoint)
            .then(() => {
              this.$message({
                message: this.$t('RestList_DeleteSuccessMessage'),
                type: 'success'
              })

              const listComponent = this.$refs[componentRefName]

              if (listComponent) {
                if (listComponent.$refs && listComponent.$refs.restList) {
                  listComponent.$refs.restList.refresh()
                }
              }
            })
            .catch(error => {
              this.$message({
                message: error.message,
                type: 'error'
              })
            })
          this.cancelDelete()
        },
        getWarningItems() {
          if (getWarningItems && typeof getWarningItems === 'function') {
            return getWarningItems.call(this)
          }
          return []
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/consent-manager/utils/deletePopupWarningUtils.js